import React from 'react';

import { Callout } from './Callout';
import { Divider } from '../Divider';
import UniversalNavLink from '../../UniversalNavLink';
import { isLinkSelected } from './utils';

import type { SidebarV3 } from './types';

type InAppLinksProps = {
  isCollapsed: boolean;
  links: Array<SidebarV3.ItemGroup>;
  callout?: SidebarV3.Callout;
  selectedHref: string;
};

const InAppLinks = ({
  isCollapsed,
  links,
  callout,
  selectedHref,
}: InAppLinksProps) => (
  <React.Fragment>
    {links.map((itemGroup, index) => (
      <React.Fragment key={index}>
        <li aria-hidden="true" key={index}>
          <Divider />
        </li>

        {itemGroup?.map((item) => {
          const isSelected = isLinkSelected(item.href || '', selectedHref);

          const icon = isSelected ? item.iconFilled : item.icon;

          return (
            <li key={item.text}>
              <UniversalNavLink
                href={item.href!}
                icon={icon}
                isCollapsed={isCollapsed}
                isSelected={isSelected}
                isSidebar={true}
                isV3Link={true}
                text={item.text}
                tag={item.tag}
              />
            </li>
          );
        })}
      </React.Fragment>
    ))}

    {callout && !isCollapsed && (
      <li key="callout">
        <Callout {...callout} />
      </li>
    )}
  </React.Fragment>
);

export default InAppLinks;
